import {VueClass, VueRequireComponent, VueVar} from "horizon-js-front-sdk/lib/VueAnnotate";
import html from "./SidebarView.html";
import {Autowire} from "horizon-js-front-sdk/lib/DependencyInjector";
import EstablishmentRepository from "../repositories/EstablishmentsRepository";
import Establishment from "../class/accounting/Establishment";
import Vue from "vue";
import AppStateListener from "../listener/AppStateListener";
import {SidebarComponent, SidebarHeader, SidebarMenu} from "vue-interface-sdk/src/component/sidebar/sidebar";

let el = document.getElementById('sidebar');
if (el) {
	el.innerHTML = html;
}

@VueRequireComponent('sidebar', SidebarComponent)
@VueClass()
export class SidebarView extends Vue {
	@VueVar() opened: boolean = false;
	@VueVar() hiddenSidebar: boolean = false;
	@VueVar() minimized: boolean = false;
	@VueVar() establishments: Establishment[] = [];
	@VueVar() currentEstablishment: Establishment | null = null;

	@VueVar() displayMobileMenu!: boolean;
	@VueVar() header?: SidebarHeader;

	menusTop: SidebarMenu = {
		separator: false,
		navigations: [
			{icon: 'fa-house-blank', title: 'Accueil', url: '/'}
		]
	};
	@VueVar() menus: SidebarMenu[] = [this.menusTop];


	@Autowire(EstablishmentRepository) establishmentRepository!: EstablishmentRepository;
	@Autowire(AppStateListener) appStateListener!: AppStateListener;

	constructor(container: string, vueConstructor: any = null) {
		super(vueConstructor);
		this.establishmentRepository.getAll().then((establishments: Establishment[]) => {
			this.establishments = establishments;
			this.get_current_establishment();
		});

		this.appStateListener.listen((event: { type: string, value: any }) => {
			if (event.type === 'openedSidebar') {
				this.opened = event.value;
			} else if (event.type === 'minimizedSidebar') {
				this.minimized = event.value;
			} else if (event.type === 'hiddenSidebar') {
				this.hiddenSidebar = event.value;
			}
		});
	}


	get_current_establishment() {
		this.establishmentRepository.get_current_establishment_uid().then((establishmentUid) => {
			for (let establishment of this.establishments) {
				if (establishment.uid === establishmentUid) {
					this.currentEstablishment = establishment;
					this.header = {
						icon: 'fa-circle-user'
						, title: this.currentEstablishment.name
						// , subtitle: 'Elon MUSK'
						// , iconAction: 'fa-repeat'
						// , clickable: false
					}

					this.init_invoicing();
					this.init_bank();
					this.init_manage_stock();
					this.init_manage_rh();
					this.init_parameters();
					this.init_integration();
				}
			}

		});
	}

	init_invoicing() {
		if (!this.currentEstablishment) {
			return;
		}
		if (this.currentEstablishment.is_all_allowed) {
			this.menus.push({
				title: "Facturation",
				action: {
					icon: 'fa-circle-plus',
					url: EstablishmentRepository.getPathNameWithEstablishmentUid("/facturer/")
				},
				navigations: [
					{
						icon: 'fa-file-invoice-dollar',
						title: 'Ventes',
						url: EstablishmentRepository.getPathNameWithEstablishmentUid("/factures/")
					},
					{
						icon: 'fa-file-invoice',
						title: 'Achat',
						url: EstablishmentRepository.getPathNameWithEstablishmentUid("/factures-achat/")
					},{
						icon: 'fa-message-bot',
						title: 'Génération automatique',
						url: EstablishmentRepository.getPathNameWithEstablishmentUid("/import-fournisseur/")
					},
					{
						icon: 'fa-square-poll-vertical',
						title: 'Statistiques factures',
						url: EstablishmentRepository.getPathNameWithEstablishmentUid("/statistiques/")
					}
				]
			});
		}
	}

	init_bank() {
		if (!this.currentEstablishment) {
			return;
		}
		if (this.currentEstablishment.is_all_allowed) {
			this.menus.push({
				title: "Banque",
				navigations: [
					{
						icon: 'fa-ballot-check',
						title: 'Rapprochement',
						url: EstablishmentRepository.getPathNameWithEstablishmentUid("/rapprochement/")
					},
					{
						icon: 'fa-rotate',
						title: 'Synchronisation',
						url: EstablishmentRepository.getPathNameWithEstablishmentUid("/comptes/")
					},
				]
			});
		}
	}

	init_manage_stock() {
		if (!this.currentEstablishment) {
			return;
		}
		let navigation: SidebarMenu = {
			title: "Gestion de stock",
			navigations: []
		}

		if (this.currentEstablishment.is_productRead_allowed) {
			navigation.navigations.push({
				icon: 'fa-dolly',
				title: 'Produits',
				url: EstablishmentRepository.getPathNameWithEstablishmentUid("/produits/")
			});
		}
		if (this.currentEstablishment.is_inventoryRead_allowed) {
			navigation.navigations.push({
				icon: 'fa-boxes-stacked',
				title: 'Inventaire',
				url: EstablishmentRepository.getPathNameWithEstablishmentUid("/inventaires/")
			});
		}
		if (navigation.navigations.length > 0) {
			navigation.navigations.push({
				icon: 'fa-square-poll-vertical',
				title: 'Statistiques produits',
				url: EstablishmentRepository.getPathNameWithEstablishmentUid("/statistiques-produit/")
			});
			this.menus.push(navigation);
		}
	}

	init_manage_rh() {
		if (!this.currentEstablishment) {
			return;
		}
		let navigation: SidebarMenu = {
			title: "Ressources humaines",
			navigations: []
		}

		if (this.currentEstablishment.is_employeeRead_allowed) {
			navigation.navigations.push({
				icon: 'fa-users-medical',
				title: 'Employés',
				url: EstablishmentRepository.getPathNameWithEstablishmentUid("/employes/")
			});
			navigation.navigations.push({
				icon: 'fa-user-check',
				title: 'Pointeuse',
				url: EstablishmentRepository.getPathNameWithEstablishmentUid("/pointeuse/")
			});
		}
		if (this.currentEstablishment.is_turnoverTargetsRead_allowed) {
			navigation.navigations.push({
				icon: 'fa-bullseye-arrow',
				title: 'Objectifs',
				url: EstablishmentRepository.getPathNameWithEstablishmentUid("/objectifs/")
			});
		}
		if (this.currentEstablishment.is_employeeUpdate_allowed) {
			navigation.navigations.push({
				icon: 'fa-calendar-circle-user',
				title: 'Calendrier',
				url: EstablishmentRepository.getPathNameWithEstablishmentUid("/planning/")
			});
		}
		if (navigation.navigations.length > 0) {
			this.menus.push(navigation);
		}
	}

	init_parameters() {
		if (!this.currentEstablishment) {
			return;
		}
		let navigation: SidebarMenu = {
			title: "Paramètres",
			navigations: []
		}

		navigation.navigations.push({
			icon: 'fa-swatchbook',
			title: 'Template de facture',
			url: EstablishmentRepository.getPathNameWithEstablishmentUid("/templates/")
		});

		if (navigation.navigations.length > 0) {
			this.menus.push(navigation);
		}
	}

	init_integration() {
		if (!this.currentEstablishment) {
			return;
		}
		let navigation: SidebarMenu = {
			title: "Intégration",
			navigations: []
		}

		navigation.navigations.push({
			icon: 'fa-cash-register',
			title: 'Caisse enregistreuse',
			url: EstablishmentRepository.getPathNameWithEstablishmentUid("/liens/")
		});

		navigation.navigations.push({
			icon: 'fa-ticket-simple',
			title: 'Billetterie en ligne',
			url: EstablishmentRepository.getPathNameWithEstablishmentUid("/liens/")
		});

		if (navigation.navigations.length > 0) {
			this.menus.push(navigation);
		}
	}
}